import React from "react";

const TEXT_CONTENT = {
  introduction: `
    Empathy värnar om individers personliga integritet och strävar efter att arbeta med kunder och leverantörer som lever upp till de krav som ställs på företag som behandlar personuppgifter. Vi behandlar, inom ramen för våra verksamhetsområden tester, personbedömningar, utveckling och utbildning en mängd personuppgifter, inte sällan av känslig art.
    Detta dokument har tagits fram i syfte att tydliggöra vårt ansvar och hur vi uppfattar vårt personuppgiftsansvar enligt gällande personuppgiftslagstiftning (GDPR).
    Personuppgifter är information som enskilt eller tillsammans med andra uppgifter kan användas för att identifiera, lokalisera eller kontakta en individ. Exempel på personuppgifter är namn, telefonnummer och IP-adress med flera. Behandling av personuppgifter innebär all typ av hantering av personuppgifter, till exempel insamling, analysering, registrering och lagring.
  `,
  sections: [
    {
      title: "Empathy är personuppgiftsansvarig",
      content: `
        Personuppgiftsansvarig är den som fastställer syftet med behandling av personuppgifter som efterfrågas. Det är personuppgiftsansvarig som är ytterst ansvarig för att behandlingen av dina personuppgifter sker enligt gällande personuppgiftslagstiftning.
      `,
    },
    {
      title: "Policyns syfte och tillämplighet",
      content: `
        Denna policy syftar till att informera dig om hur Empathy behandlar personuppgifter om dig när Empathy behandlar personuppgifter om dig vilka personuppgifter Empathy behandlar om dig och för vilka ändamål, samt vilka rättigheter du har i egenskap av registrerad.
      `,
    },
    {
      title: "Varför behandlar vi dina personuppgifter?",
      content: `
        För att kunna ingå avtal, direkt med dig eller med kund /nuvarande arbetsgivare, kunna utföra och leverera våra tjänster tillhandahålla fakturor eller annat beställningsunderlag, besvara inkommande frågor erbjuda befintliga eller nya tjänster, samt erbjuda dig service på webbplats samt service under och efter köp.
        När du besöker Empathys webbplats kan Empathy enbart identifiera din IP-adress, varifrån anropet till webbplatsen görs. Trots denna uppgift förblir du anonym, om du inte själv väljer att lämna uppgifter som kan identifiera dig, exempelvis genom att skicka e-postmeddelande.
      `,
    },
    {
      title: "Personuppgifter kopplat till målgruppen Kunder",
      content: `
        Vilken typ av personuppgifter behandlar vi?
        De uppgifter vi hanterar är: efternamn, förnamn, titel, e-postadress och inloggningsinformation, i förekommande fall IP-adress.
        Hur använder vi informationen?
        I vårt avtal för att juridiskt reglera affärsrelationen I våra fakturor, för att kunna ta betalt för våra tjänster I vår kundservice för att kunna skicka efterfrågade textlänkar.
        Till vilka lämnar vi ut dina uppgifter?
        Till tjänsteleverantörer för att uppnå ovan nämnda ändamål. Vi lämnar i övrigt inte ut dina uppgifter till tredje part.
        Vilka rättsliga grunder gäller?
        Den rättsliga grunden för de uppgifter vi hanterar är huvudsakligen ”avtal”. Vid direktutskick och marknadsföringsaktiviteter gäller ”samtycke”.

        Hur länge behandlar/sparar vi dina personuppgifter?
        Vi sparar inte dina uppgifter.
      `,
    },
    {
      title:
        "Personuppgifter kopplat till målgruppen utbildningsdeltagare eller annan deltagare",
      content: `
        Vilken typ av personuppgifter behandlar vi?
        För att kunna hantera dig eller någon annan i din organisation gällande en utbildning eller utvecklingsinsats så behöver vi e-post, namn, telefonnummer, i förekommande fall IP-adress.
        Hur använder vi informationen?
        I detta fall använder vi dina personuppgifter dels för att kunna skicka ut eventuella tester du ska genomföra. I ett utvecklingsprogram noterar vi även vissa uppgifter som är relevanta under, eller inför, ett utvecklingsprogram.
        Till vilka lämnar vi ut dina uppgifter?
        Till tjänsteleverantör för tester som används i ovan ändamål.
        Vilken rättslig grund gäller?
        Den rättsliga grunden för de uppgifter vi hanterar är ”avtal”.
        Hur länge behandlar/sparar vi dina personuppgifter?
        Vi sparar dina uppgifter så länge vi behöver uppgifterna för att kunna tillgodose den tjänst som är köpt, eller till dess vi genomfört uppdraget hos kund. Vi raderar dina uppgifter 12 månader efter att vi slutfört uppdraget för vår kund.
      `,
    },
    {
      title: "När lämnar vi ut dina uppgifter?",
      content: `
        Lämnade uppgifter kommer att vara tillgängliga för ett begränsat antal personer hos Empathy, oftast enbart den handläggande personen.
        Vi kan, i särskilda fall, lämna ut dina uppgifter om det är nödvändigt för att bevaka, fastställa eller utöva rättsliga anspråk. Det kan bland annat ske när det finns skäl att tro att uppgifterna är nödvändiga för att identifiera, kontakta, eller föra talan mot någon som kan ha gjort intrång på webbplatsen och/eller brutit mot våra allmänna villkor, eller som på annat sätt gjort intrång eller inkräktar på Empathys rättigheter eller egendom.
        Utlämnande av dina uppgifter kan också ske om det krävs enligt lag eller om det är nödvändigt att Empathy ska kunna uppfylla sina lagstadgade eller avtalsenliga förpliktelser.
        Vi garanterar också att vi inte kommer att sälja dina personuppgifter vidare för direktmarknadsföring av tredje part.
      `,
    },
    {
      title: "Säkerhet & incidentrapportering",
      content: `
        Empathy är mån om att skydda dina personuppgifter. De säkerhetsåtgärder vi har vidtagit har skett med utgångspunkt i de tekniska möjligheter som finns, kostnaderna för åtgärderna, de risker som finns samt de behandlade uppgifternas känslighet.
        Vi hanterar uppgifterna inom ramen för dataskyddsförordningen, GDPR. All information omfattas av sekretessavtal och vår personal har tillgång endast till de system och funktioner som deras arbetsuppgifter kräver.
        Din personliga, känsliga information om t ex testresultat förblir anonyma då dessa inte sparas baserat på din identitet.
        Empathy har vidtagit säkerhetsåtgärder i syfte att skydda dina personuppgifter från obehörig åtkomst eller annan form av obehörigt användande.
        Empathy har säkerställt att våra leverantörer och de juridiska personer som behandlar våra personuppgifter har vidtagit skäliga tekniska och organisatoriska säkerhetsåtgärder. All Empathys datatrafik sker inom ett säkert nätverk med brandvägg.
      `,
    },
    {
      title: "Personuppgiftsincidenter",
      content: `
        Om vi upptäcker att dina personuppgifter har blivit förstörda, kommit i orätta händer eller på annat sätt gått förlorade kommer vi att rapportera det till Datainspektionen inom 72 timmar efter upptäckt. För det fall en sådan personuppgiftsincident inträffar kommer vi att informera dig om detta.
      `,
    },
    {
      title: "Dina rättigheter",
      content: `
        Enligt dataskyddsförordningen har du som registrerad åtskilliga rättigheter. Du har när som helst rätt att kontakta Empathy för att utöva dina rättigheter. Det gör du enklast genom att ta kontakt med oss på info@empathy.nu
        Empathy kan komma att vidta skydds- och säkerhetsåtgärder för att säkerställa att du är den du utger dig att vara. Om du inte, på ett trovärdigt sätt, kan visa din identitet kan Empathy underlåta att tillgodose din begäran. Här nedan kan du läsa om de rättigheter du har enligt dataskyddsförordningen och vad rättigheterna innebär.
        Empathy kan välja att ta ut en rimlig avgift som täcker de administrativa kostnaderna för att tillhandahålla den information eller vidta den åtgärd som begärts eller neka att tillmötesgå begäran.
      `,
    },
    {
      title: "Tillgång till personuppgifter",
      content: `
        Du har rätt att begära tillgång till de personuppgifter vi behandlar om dig.
      `,
    },
    {
      title: "Dataportabilitet",
      content: `
        Du har under vissa förutsättningar rätt att få de uppgifter vi behandlar om dig i ett allmänt, skriftligt, maskinläsbart och strukturerat format. Denna rätt gäller endast de personuppgifter som du själv har tillhandahållit oss och som behandlas med stöd av de rättsliga grunderna samtycke eller ingående/fullgörande av avtal.
      `,
    },
    {
      title: "Begränsning av behandling",
      content: `
        Du har rätt till begränsning av dina personuppgifter. Med begränsning menas att uppgifterna markeras så att dessa i framtiden endast får behandlas för vissa avgränsade syften.
      `,
    },
    {
      title: "Rätt att inge klagomål",
      content: `
        Om du anser att vi behandlar dina personuppgifter på ett felaktigt sätt har du rätt att inge klagomål till tillsynsmyndighet.
      `,
    },
    {
      title: "Kontaktuppgifter och information om personuppgiftsansvarig",
      content: `
        Empathy One 969786 – 9619 är personuppgiftsansvariga för de uppgifter företaget behandlar om dig. Har du frågor om vår behandling eller önskar komma i kontakt med oss för att utöva dina rättigheter, hittar du våra kontaktuppgifter på vår kontaktsida.
      `,
    },
  ],
};

const GDPR: React.FC = () => {
  const highlightText = (text: string) => {
    const highlighted = text.replace(
      /(969786 – 9619)/g,
      '<span style="text-decoration: underline;">$1</span>'
    );
    return <span dangerouslySetInnerHTML={{ __html: highlighted }} />;
  };
  return (
    <div className="flex flex-col justify-center items-center text-white text-start">
      <div className="max-w-[1260px] p-7 pt-2 px-2 flex flex-col gap-[36px] bg-primary-card rounded-xl">
        <p className="font-quicksand text-[16px] font-normal whitespace-pre-line">
          {TEXT_CONTENT.introduction}
        </p>
        {TEXT_CONTENT.sections.map((section, index) => (
          <div key={index}>
            <h3 className="font-nunito text-[24px] font-semibold leading-[32px]">
              {`${index + 1}. ${section.title}`}
            </h3>
            <p className="font-quicksand text-[16px] font-normal leading-[28px] whitespace-pre-line">
              {highlightText(section.content)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GDPR;
